<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="attenstatus" v-if="status==1 && type==1">
                <div>
                    <img src="@/assets/images/personDone.png" alt="">
                    <p>已认证为自然人用户</p>
                </div>
            </div>
            <div class="account-type" v-else>
                <h4>请选择一种账号类型</h4>
                <p class="warning">
                    <i class="el-icon-warning"></i
                    >&nbsp;&nbsp;&nbsp;&nbsp;一个账号只能认证一种类型，认证成功后不可修改。请谨慎选择。
                </p>
                <ul class="choose">
                    <li @click="goattestation(1)">
                        <dl>
                            <dt>
                                <img src="@/assets/images/gr.png" alt="" />
                            </dt>

                            <dd>
                                <h3>个人账号</h3>
                            </dd>
                        </dl>
                    </li>
                    <li @click="goattestation(2)">
                        <dl>
                            <dt>
                                <img src="@/assets/images/qy.png" alt="" />
                            </dt>

                            <dd>
                                <h3>企业账号</h3>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>
    </el-row>
</template>

<script>
import {entStatusInfo} from '@http/user_center/realName'
export default {
    data() {
        return {
            type: "",
            status: "4",
            reason: "",
            entStatus:'',
        };
    },

    components: {},

    computed: {},

    async created() {
        let that = this;
        let {status}=await entStatusInfo();
        this.entStatus=status;
        this.$request({
            method: "get",
            url: "/identification/info",
        })
        .then((res) => {
            console.log(res);
            that.status = res.data.status;
            that.type = res.data.type;
            that.reason = res.data.reason;
        })
        .catch((err) => {
            console.log(err);
        });
    },

    mounted() {},

    methods: {
        choose() {
            (this.status = ""), (this.type = 2);
        },
        goattestation(n) {
            if (n == 1) {
                if(this.type==2){
                    this.$msg('您已进行企业实名认证，无法在进行个人实名认证','info',6000)
                }else{
                    if(this.$getlocalStorage('queryData').identifyType==1 || this.$route.query.identifyType==1){
                        //壹签用户。
                        this.$router.push({
                            path: "/userCenter/Personbank",
                        });
                    }else{
                        this.$router.push({
                            path: "/userCenter/AuthenticationName/Individual",
                        });
                    }
                }
            } else {
                if(this.entStatus==0){
                    //未认证去识别企业信息页
                    this.$router.push({
                        path: "/userCenter/realName/enterpriseIndex",
                    });
                }else if(this.entStatus==1){
                    //企业信息已识别，直接选择授权方式
                    this.$router.push({
                        path:'/userCenter/realName/enterpriseAuthorize'
                    })
                }else if(this.entStatus==2){
                    //线下授权书申请审核中，去对公打款页
                    this.$router.replace({
                        path:'/userCenter/realName/enterpriseResult'
                    })
                }else{
                    //已完成认证
                    this.$router.replace({
                        path:'/userCenter/realName/enterpriseSuccess'
                    })
                    //this.$msg('您的企业认证已完成','success');
                }
            }
        }
    },
};
</script>
<style src="../../../assets/css/content.css" scoped></style>

<style scoped>
.warning {
    font-size: 14px;
}
.account-type {
    padding-top: 31px;
    width: 930px;
    margin: 0 auto;
}

.account-type h4 {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    margin-bottom: 20px;
}

.choose {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 30px;
}

.choose li {
    width: 420px;
    border: 1px solid #d9d9d9;
    cursor: pointer;
}

.ico {
    width: 40px;
    height: 40px;
}

.choose li:hover {
    border-color: #3f7df7;
    background: #f9fbff;
}

.choose li:hover .ico {
    color: #3f7df7;
}

.choose dl {
    display: flex;
    flex-direction: row;
    padding-left: 30px;
    align-items: center;
    height: 91px;
}

.choose dl dd {
    margin-left: 19px;
    width: 20%;
}

.choose dl dd h3 {
    font-size: 16px;
    margin-bottom: 9px;
}

.choose dl dd p {
    color: #3f7df7;
    font-size: 12px;
}

.attenstatus {
    text-align: center;
    padding: 50px 0;
}
.attenstatus p {
    margin: 10px 0;
    font-size: 16px;
    color: #333;
    font-weight: 600;
}
.reasons {
    font-size: 14px;
    color: #999;
}
.goattestation span {
    margin-top: 20px;
    display: inline-block;
    width: 110px;
    height: 33px;
    line-height: 33px;
    border: 1px solid #3f7df7;
    color: #3f7df7;
    border-radius: 33px;
    cursor: pointer;
}
.goattestation span:hover {
    color: #fff;
    background: #3f7df7;
}
</style>
